import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActionArea, Grid, Typography, Slider } from '@material-ui/core';
import MoneyIcon from  '@material-ui/icons/DirectionsRun';

const useStyles = makeStyles(theme => ({
 root: {
    height: '100%',
    padding: 0
  },
 
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center'
  },
                               
  icon: {
    color: theme.palette.info.main,
    height: 24,
    width: 24                   
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  panel: {
    paddingTop:0,
    paddingBottom:'0 !important'
  },
  slider: {
    paddingTop:15,
    paddingBottom:15
  }

}));


const marks = [
  {
    value: 0,
    label: '0',
  },
  {
    value: 5,
    label: '5 km/h',
  },  
  {
    value: 10,
    label: '10',
  },
  {
    value: 15,
    label: '15',
  }
];

const SpeedFlatCard = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.panel}>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              Speed on Flat
            </Typography>
            
          </Grid>
          <Grid item>
            <MoneyIcon className={classes.icon} />
          </Grid>
        </Grid> 
              <CardActionArea>
        <Slider  className={classes.slider}
          defaultValue={5}
          aria-labelledby="discrete-slider-always"
          step={1}
          marks={marks}
          valueLabelDisplay="auto"
          component="div"
          max={15}
        />
      </CardActionArea>
      </CardContent>
    </Card>
  );
};

SpeedFlatCard.propTypes = {
  className: PropTypes.string
};

export default SpeedFlatCard;
